var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolder2Crossed = function SvgFolder2Crossed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M47.667 20.625v11.25c0 7.5-2.167 9.375-10.834 9.375H15.167c-8.667 0-10.834-1.875-10.834-9.375v-18.75c0-7.5 2.167-9.375 10.834-9.375h3.25c3.25 0 3.965.825 5.2 2.25l3.25 3.75c.823.938 1.3 1.5 3.466 1.5h6.5c8.667 0 10.834 1.875 10.834 9.375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M17.333 3.75h19.5c4.334 0 6.5 1.875 6.5 5.625v2.588",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.242 21.243 8.485 8.485M22.242 29.728l8.485-8.485"
  }))));
};
export default SvgFolder2Crossed;